module.exports = __webpack_public_path__ + "static/tag-financial-planning-logo-f9e3f6f5dd7dd94a8eec897ca2d05751.svg";